import {
  Box,
  VStack,
  Card,
  CardHeader,
  CardBody,
  Button,
  Heading,
  Text,
  Link,
  CardFooter,
  Center,
  Image,
} from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { getHighlightData } from "../../../store/highlight/selectors";
import { getData } from "../../../store/site/selectors";
import DoubleColumn from "../../molecules/DoubleColumn";
import useHightlight from "../../../utils/hooks/useHighlight";
import { useNavigate } from "react-router";
import { ROUTES } from "../../../utils/constants";
import { SocialButtons } from "../../atoms";
import tally from "../../../assets/tally_l.png";
import Locandina from "../../molecules/Locandina";

export default function Home() {
  useHightlight();
  const highlights = useSelector(getHighlightData);
  const dates = useSelector(getData);
  const navigate = useNavigate();

  return (
    <>
      <Center mb="20px">
        <VStack>
          <Heading size="lg" color="talesBlack">
            Ingresso gratuito!
          </Heading>
          <Heading size="base" textAlign="center">
            {dates}
            <br />
            Montagnana, 35044 - PD
            <Heading size="base" fontWeight="normal">
              Nei dintorni della Rocca degli Alberi!
            </Heading>
          </Heading>
        </VStack>
      </Center>

      <DoubleColumn>
        <Card bg="white" width="100%" height="100%">
          <CardHeader m="auto">
            <Heading size="md">IN EVIDENZA</Heading>
          </CardHeader>
          <CardBody>
            {(highlights == null ||
              highlights.length === 0 ||
              !highlights.some((highlight) => highlight.show)) && (
              <>
                <Heading size="base">
                  Vuoi essere un nostro espositore, sponsor o volontario?
                </Heading>
                <Text>
                  Contattaci sui nostri social o via email a
                  <Text as="span" fontWeight="bold">
                    &nbsp;talesmontagnana@gmail.com
                  </Text>
                </Text>
                <SocialButtons />
              </>
            )}
            {highlights?.map((highlight) => {
              return highlight.show ? (
                <Box key={highlight.id} marginBottom="20px">
                  <Heading size="base">{highlight.title}</Heading>
                  <Text whiteSpace="pre-line">
                    {highlight.content} <br />
                    {highlight.link && (
                      <Link href={highlight.link}>{highlight.link}</Link>
                    )}
                  </Text>
                </Box>
              ) : null;
            })}
          </CardBody>
        </Card>
        <VStack spacing="20px" height="100%" key="rightColumn">
          <Card bg="white" width="100%">
            <CardHeader m="auto">
              <Heading size="md">Lo sapevi che?</Heading>
            </CardHeader>
            <CardBody>
              <Text>
                <strong>Montagnana</strong> è uno dei{" "}
                <strong>Borghi più belli d'Italia</strong> che conserva la{" "}
                <strong>cinta muraria medievale</strong> ancora intatta!
              </Text>
            </CardBody>
          </Card>
          <Card bg="talesSecondary.500" width="100%">
            <CardHeader m="auto">
              <Heading size="md" color="talesWhite">
                Cosa si fa a tales?
              </Heading>
            </CardHeader>
            <CardBody>
              <Text color="white">
                Di tutto e di più! Tornei, cosplay, raduni, cibo, musica,
                fumetti, e chi più ne ha più ne metta!
              </Text>
            </CardBody>
            <CardFooter m="auto">
              <Button onClick={() => navigate(ROUTES.PROGRAMMA)}>
                Guarda il programma
              </Button>
            </CardFooter>
          </Card>
          <Locandina />
          <Card bg="white" width="100%">
            <Card bg="white" width="100%">
              <CardHeader m="auto">
                <Heading size="md">Tally si presenta</Heading>
              </CardHeader>
              <CardBody>
                <Box
                  marginBottom="20px"
                  margin={"auto"}
                  width={"100%"}
                  height={"80%"}
                >
                  <Text>
                    Mi presento: sono Tally, il vostro nuovo compagno di
                    avventure e appassionato giocatore di videogiochi, creato da{" "}
                    <Link href={"https://www.instagram.com/crizenart"}>
                      CrizenArt
                    </Link>
                    .{" "}
                  </Text>
                  <Text mt={"15px"}>
                    <strong>
                      Sono qui per portare allegria e divertimento a Tales
                      Montagnana con la mia magia!
                    </strong>
                  </Text>
                  <Image src={tally} height={"75%"} ml={"18%"} />
                  <Text my={"15px"}>
                    <strong>
                      Scopriremo insieme un mondo dove giochi, avventure e
                      fantasia diventano realtà
                    </strong>{" "}
                    e vivremo delle giornate indimenticabili!
                  </Text>
                </Box>
              </CardBody>
            </Card>
          </Card>
        </VStack>
      </DoubleColumn>
    </>
  );
}
